function Directive() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      admissionGroup: '='
    },
    template: `<span class="badge {{ getClass() }}" ng-show="admissionGroup.paymentStatus">
      {{ getText() }}
    </span>`,
    controller: [
      '$scope',
      ($scope) => {
        $scope.getText = function () {
          if ($scope.admissionGroup.paymentStatus === 'FULL') return 'Prepaid Full';
          else if ($scope.admissionGroup.paymentStatus === 'DEPOSIT') return 'Prepaid Deposit';
          else if ($scope.admissionGroup.paymentStatus === 'CREDIT_CARD_ON_FILE') return 'Auth';
          return '';
        };

        $scope.getClass = function () {
          if ($scope.admissionGroup.paymentStatus === 'FULL' || $scope.admissionGroup.paymentStatus === 'DEPOSIT') return 'badge-prepaid';
          return '';
        };
      }
    ]
  };
}

Directive.$inject = [];

export default Directive;



// WEBPACK FOOTER //
// ./src/directives/admissionGroupPaymentStatusLabel.js